// extracted by mini-css-extract-plugin
export default {"centered-view":"_pv3o0u","centeredView":"_pv3o0u","installed-icon":"_fu8zos","installedIcon":"_fu8zos","bundle-badge":"_1pitnx4","bundleBadge":"_1pitnx4"};